import React from "react";
import { Col, Container, Row, Card } from "react-bootstrap";
import TableLayout from "../../../components/TableLayout";
import CustomPagination from "../../../components/Common/CustomPagination";
import ConfirmationPop from "../../../components/Modals/ConfirmationPop";
import Filter from "../../../components/Common/Filter";
import { activeInactiveOptions } from "../../../utilities/const";
import TableActions from "../../../components/Common/TableActions";
import moment from "moment";
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
} from "recharts";


const referralData = {
  totalReferrals: 1200,
  totalRewards: 450,
  rewardsDistributed: 320,
  clickThroughRate: 0.45,
  signUpConversions: 0.25,
  bookingsMade: 150,

  codes: [
    { name: "REF123", value: 120 },
    { name: "BONUS50", value: 95 },
    { name: "SAVE10", value: 80 },
    { name: "WELCOME", value: 60 },
  ],

  engagement: [
    { stage: "Clicks", count: 500 },
    { stage: "Signups", count: 200 },
    { stage: "Bookings", count: 150 },
  ],

  table: [
    {
      _id: "1",
      userName: "Alice",
      referralCode: "REF123",
      reward: 50,
      clicks: 30,
      signups: 10,
      bookings: 5,
      createdAt: "2024-09-01T12:00:00Z",
      status: "active",
    },
    {
      _id: "2",
      userName: "Bob",
      referralCode: "BONUS50",
      reward: 30,
      clicks: 20,
      signups: 8,
      bookings: 3,
      createdAt: "2024-09-02T15:00:00Z",
      status: "inactive",
    },
  ],
};

const COLORS = ["#8884d8", "#82ca9d", "#ffc658", "#ff7f50"];

const ManageReferral = () => { 
  const body = { limit: 10, page: 1 };
  const data = referralData.table;
  const loader = false;
  const total = referralData.table.length;

  const columns = [
    {
      head: "#",
      accessor: "#",
      component: (item, key) => body.limit * (body.page - 1) + key + 1,
    },
    { head: "User", accessor: "userName", component: (item) => item.userName },
    {
      head: "Referral Code",
      accessor: "referralCode",
      component: (item) => item.referralCode,
    },
    { head: "Reward", accessor: "reward", component: (item) => item.reward },
    { head: "Clicks", accessor: "clicks", component: (item) => item.clicks },
    { head: "Signups", accessor: "signups", component: (item) => item.signups },
    {
      head: "Bookings",
      accessor: "bookings",
      component: (item) => item.bookings,
    },
    {
      head: "Created At",
      accessor: "createdAt",
      component: (item) => moment(item.createdAt).format("MM-DD-YYYY, HH:mm"),
    },
    {
      head: "Status",
      accessor: "status",
      component: (item) => (
        <span
          className={`badge ${
            item.status === "active" ? "bg-success" : "bg-secondary"
          }`}
        >
          {item.status}
        </span>
      ),
    },
    {
      head: "Action",
      accessor: "action",
      component: (item) => (
        <TableActions
          viewLink={`/manage-referral/detail/${item._id}`}
          editUrl={`/manage-referral/edit/${item._id}`}
        />
      ),
    },
  ];

  return (
    <>
      <section className="manageReferral py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12">
              <h4 className="fw-bold text-dark text-capitalize py-3">
                Referral Management Dashboard
              </h4>
            </Col>

            <Col lg="3" className="mb-3">
              <Card className="p-3 shadow-sm text-center">
                <h6 className="">Total Referrals</h6>
                <h3>{referralData.totalReferrals}</h3>
              </Card>
            </Col>
            <Col lg="3" className="mb-3">
              <Card className="p-3 shadow-sm text-center">
                <h6 className="">Total Rewards</h6>
                <h3>{referralData.totalRewards}</h3>
              </Card>
            </Col>
            <Col lg="3" className="mb-3">
              <Card className="p-3 shadow-sm text-center">
                <h6 className="">Bookings Made</h6>
                <h3>{referralData.bookingsMade}</h3>
              </Card>
            </Col>
            {/* <Col lg="3" className="mb-3">
              <Card className="p-3 shadow-sm text-center">
                <h6 className="">CTR (%)</h6>
                <h3>{(referralData.clickThroughRate * 100).toFixed(1)}%</h3>
              </Card>
            </Col> */}

            {/* <Col lg="6" className="mb-3">
              <Card className="p-3 shadow-sm">
                <h6>Referral Code Usage</h6>
                <PieChart width={400} height={250}>
                  <Pie
                    data={referralData.codes}
                    dataKey="value"
                    nameKey="name"
                    outerRadius={80}
                    label
                  >
                    {referralData.codes.map((entry, index) => (
                      <Cell
                        key={`cell-${index}`}
                        fill={COLORS[index % COLORS.length]}
                      />
                    ))}
                  </Pie>
                  <Tooltip />
                  <Legend />
                </PieChart>
              </Card>
            </Col> */}

            {/* <Col lg="6" className="mb-3">
              <Card className="p-3 shadow-sm">
                <h6>Engagement (Clicks → Signups → Bookings)</h6>
                <BarChart
                  width={400}
                  height={250}
                  data={referralData.engagement}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="stage" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="count" fill="#8884d8" />
                </BarChart>
              </Card>
            </Col> */}

            <Col lg="12" className="my-2">
              <Filter
                body={body}
                searchHandler={() => {}}
                setBody={() => {}}
                statusFilterOptionArr={activeInactiveOptions}
              />
            </Col>

        
            <Col lg="12" className="my-2">
              <TableLayout column={columns} data={data} loader={loader} />
              <CustomPagination
                total={total}
                pageChangeHandler={() => {}}
                body={body}
                setBody={() => {}}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default ManageReferral;
